import type { Components } from 'react-markdown';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const defaultRenderers = {
  h1: ({ node, ...props }) => <h1 className="mt-8 mb-4 text-left text-xl font-bold first-letter:uppercase lg:text-3xl" {...props}></h1>,
  h2: ({ node, ...props }) => <h2 className="my-2 mt-4 text-xl font-bold lg:text-2xl" {...props}></h2>,
  h3: ({ node, ...props }) => <h3 className="text-md my-2 mt-4 lg:text-xl" {...props}></h3>,
  p: ({ node, ...props }) => <p className="text-left lg:text-justify" {...props}></p>,
  a: ({ node, ...props }) => (
    <a
      className="text-orange hover:underline"
      href={props.href}
      target="_blank"
      rel="noopener noreferrer"
      {...props}
    >
      {props.children}
    </a>
  ),
  ul: ({ node, ...props }) => <ul className="list-disc pl-5" {...props}></ul>,
  ol: ({ node, ...props }) => <ol className="list-decimal pl-5 text-lg font-semibold" {...props}></ol>,
  li: ({ node, ...props }) => <li {...props}></li>,
} as Components;

interface MarkdownBlockProps {
  children: string;
  renderers?: Components;
}
export function MarkdownBlock({ children, renderers }: MarkdownBlockProps) {
  const components = { ...defaultRenderers, ...renderers };
  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      components={components}
    >
      {children}
    </Markdown>
  );
}
